import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../hooks/useAlert';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const { showAlert } = useAlert();
	const baseUrl = process.env.REACT_APP_BASE_URL || '/';

	useEffect(() => {
		// Check if user is already logged in
		const userId = sessionStorage.getItem('user_id');
		const username = sessionStorage.getItem('username');
		const userType = sessionStorage.getItem('user_type');

		if (userId && username) {
			setUser({ id: userId, username, userType });
		}

		setLoading(false);
	}, []);

	const login = async (username, password) => {
		try {
			const response = await fetch(`${baseUrl}api/api/login`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ username, password }),
			});

			const data = await response.json();

			if (data.error) {
				showAlert(data.error, 'danger');
				return false;
			}

			if (data.message) {
				// Store user data in session storage
				sessionStorage.setItem('user_id', data.user_id);
				sessionStorage.setItem('username', data.username);
				sessionStorage.setItem('user_type', data.user_type);

				setUser({
					id: data.user_id,
					username: data.username,
					userType: data.user_type,
				});

				console.log(data.user_type);

				if (data.user_type == 'ADMIN') navigate(`${baseUrl}admin`);

				if (data.user_type == 'TEACHER') navigate(`${baseUrl}dialogue`);

				return true;
			}

			return false;
		} catch (error) {
			console.error('Login error:', error);
			showAlert('An error occurred during login. Please try again.', 'danger');
			return false;
		}
	};

	const logout = async () => {
		try {
			const response = await fetch(`${baseUrl}api/api/logout`);
			const data = await response.json();

			// Clear session storage regardless of server response
			sessionStorage.removeItem('user_id');
			sessionStorage.removeItem('username');
			sessionStorage.removeItem('user_type');

			setUser(null);

			if (data.redirect_url) {
				navigate(data.redirect_url);
			} else {
				navigate('/login');
			}
		} catch (error) {
			console.error('Logout error:', error);
			navigate('/login');
		}
	};

	const value = {
		user,
		login,
		logout,
		isAuthenticated: !!user,
		loading,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
